import { Model, Attr, HasMany } from 'spraypaint';
import { NullProxy, RecordProxy } from 'spraypaint/lib-esm/proxies';
import LocaleItem from '../services/LocaleItem';
import Business from './Business';
import ExportMarket from './ExportMarket';
import Post from './Post';

export type TradeMissionProxy =
  | RecordProxy<TradeMission>
  | NullProxy<TradeMission>;

@Model()
export default class TradeMission extends Post {
  static jsonapiType = 'trade-missions';

  // --- Attributes
  // --------------

  @Attr() introductoryText!: PartialTranslatableText | null;

  @Attr() footerText!: PartialTranslatableText | null;

  // --- Relationships
  // -----------------

  @HasMany() exportMarkets!: ExportMarket[];

  @HasMany() businesses!: Business[];

  // --- Custom
  // ----------

  constructor(attrs?: HashAny) {
    super(attrs);

    // CHECK: Is locale creating a strong reference to this? Do we need to free it?
    this.locale = new LocaleItem(this, {
      keys: [...Object.keys(this.locale), 'introductoryText', 'footerText'],
    }).asHash();
  }
}
